import React from 'react'
import { useTranslation } from 'react-i18next'
import { getFullAttachmentUrl } from '@services/api/index.js'

const StudioCard = ({ studio, onClick }) => {
  const { t } = useTranslation()

  const getRegionText = (inlandFlag) => {
    return inlandFlag === '1' 
      ? t('partners.regions.domestic') 
      : t('partners.regions.international')
  }

  return (
    <div 
      className="bg-white rounded-lg shadow-lg overflow-hidden flex flex-col md:flex-row"
    >
      <div className="w-full md:w-1/3 h-64 md:h-auto relative">
        {studio.coverId ? (
          <img
            src={getFullAttachmentUrl(studio.coverId)}
            alt={studio.name}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full bg-gray-200 flex items-center justify-center">
            <span className="text-gray-400 text-sm">Logo</span>
          </div>
        )}
      </div>
      
      <div className="w-full md:w-2/3 p-6">
        <h3 className="text-xl font-bold text-gray-900 mb-2">
          {studio.name}
        </h3>
        <p className="text-gray-600">
          {studio.summary}
        </p>
      </div>
    </div>
  )
}

export default StudioCard 